import React, { useState } from 'react';

import Checkbox from '@/components/atoms/Checkbox';
import TermsCard from '@/components/molecules/TermsCard';
import { Button } from '@/components/ui/button';

import { terms } from '@/utils/constants';

interface ConfirmTermsSectionProps {
  onConfirm: () => void;
  onSkip?: () => void;
}

const ConfirmTermsSection: React.FC<ConfirmTermsSectionProps> = ({ onConfirm, onSkip }) => {
  const [checked, setChecked] = useState(false);

  return (
    <>
      <div className="h-fit px-4 md:px-5 max-h-full overflow-y-auto flex flex-col gap-6 py-6 md:pb-8 md:bg-white md:rounded-[24px] md:border md:mt-8 scroll-smooth">
        <TermsCard />
        <p className="text-secondary text-xs font-medium md:hidden">
          by clicking ‘CONTINUE TO SUBSCRIPTION PLAN’ I understand with BATJET Terminology.
        </p>
        <Button onClick={onConfirm} className="rounded-full uppercase text-base flex-1 md:hidden">
          continue to SUBSCRIPTION PLAN
        </Button>
      </div>
      <p className="text-secondary text-sm font-medium mt-3 hidden md:block">
        by clicking ‘CONTINUE TO SUBSCRIPTION PLAN’ I understand with BATJET Terminology.
      </p>

      <footer className="flex items-center justify-between gap-4 px-4 mt-7">
        <Button
          onClick={() => {
            if (onSkip) onSkip();
          }}
          variant={'text'}
          className="py-5 font-semibold text-lg hidden md:block"
        >
          Skip
        </Button>
        <Button
          className="rounded-full uppercase text-base hidden md:block w-fit ml-auto mr-0 md:min-h-[64px] md:px-6"
          onClick={onConfirm}
        >
          Continue to Dashboard
        </Button>
      </footer>
    </>
  );
};

export default ConfirmTermsSection;
